import { useEffect, useCallback } from "react";

interface UseBlockDownloadsProps {
  videoElement: HTMLElement | null;
  shouldBlock?: boolean;
}

export const useBlockDownloads = ({ 
  videoElement, 
  shouldBlock = true 
}: UseBlockDownloadsProps): void => {
  
  const preventDefault = useCallback((e: Event): void => {
    e.preventDefault();
  }, []);

  useEffect(() => {
    if (!videoElement || !shouldBlock) return;

    const events = ['contextmenu', 'touchstart', 'touchend', 'touchmove'] as const;
    
    events.forEach(event => {
      videoElement.addEventListener(event, preventDefault);
    });

    return () => {
      events.forEach(event => {
        videoElement.removeEventListener(event, preventDefault);
      });
    };
  }, [videoElement, shouldBlock]);
  
};